import React from 'react'
import styles from "./Resources.module.scss";
import { corporationOptions } from "../../configration_data/configration"
import { useNavigate } from 'react-router-dom';
import ProtectedPaymentRoute from '../../auth/Auth';

export default function ScorpVsCcorp() {
  ProtectedPaymentRoute()

  const navigate = useNavigate()
  const handleClick = () => {
    navigate("/services/corporation-formation")
  }

  return (
    <div className="font-sans antialiased bg-white text-[#202124]">

      {/* Hero Section */}
      <section 
        className="relative overflow-hidden pt-[140px] pb-20 lg:pt-[180px] lg:pb-28 border-b border-[#0f2c4f] flex items-center justify-center"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2560&auto=format&fit=crop')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        {/* Professional Deep Blue Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#021835] via-[#04244d]/90 to-[#04244d]/40 mix-blend-multiply"></div>
        <div className="absolute inset-0 bg-[#021835]/50"></div>

        <div className="container mx-auto px-4 lg:px-8 relative z-10 text-center flex flex-col items-center justify-center">
          <h1 className="text-4xl md:text-5xl lg:text-[4.2rem] font-medium leading-[1.12] mb-6 tracking-tight text-white max-w-4xl">
            S-Corp vs. C-Corp
          </h1>
          <p className="text-lg md:text-[1.15rem] text-white/80 leading-[1.7] font-normal max-w-2xl mx-auto">
            Understand tax structures, ownership limits, and growth potential to choose the right corporate framework.
          </p>
        </div>
      </section>

      {/* Comparison Overview */}
      <section className="py-20 lg:py-24 bg-[#f8f9fa] border-b border-[#dadce0]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16 max-w-3xl mx-auto">
            <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-sm mb-3 block">Corporate Comparison</span>
            <h2 className="text-3xl lg:text-[40px] font-medium text-[#202124] tracking-tight mb-4">Understanding the Differences</h2>
            <p className="text-[17px] text-[#5f6368] leading-relaxed">
              Corporations can choose between being classified as a C-Corporation (C-Corp) or an S-Corporation (S-Corp). Both structures offer distinct benefits and have different tax implications.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {corporationOptions.map((ele) => (
              <div 
                key={ele.id} 
                className="bg-white rounded-[12px] p-8 border border-[#dadce0] shadow-sm hover:shadow-md transition-shadow flex flex-col justify-between"
              >
                <div>
                  <h3 className="text-[22px] font-medium text-[#202124] mb-6 pb-4 border-b border-[#f1f3f4] tracking-tight">
                    {ele.title}
                  </h3>
                  <div className="space-y-5">
                    {ele.options.map((subele) => (
                      <div key={subele.id} className="flex items-start gap-3.5">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#e8f0fe] flex items-center justify-center text-[#1a73e8] mt-0.5">
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                        </div>
                        <div>
                          <span className="font-semibold text-[#202124] text-[14.5px] block mb-0.5">{subele.subheading}</span>
                          <span className="text-[#5f6368] text-[14px] leading-relaxed block">{subele.para}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Summary Note & Action */}
      <section className="py-20 bg-white border-b border-[#f1f3f4]">
        <div className="container mx-auto px-4 lg:px-8 max-w-4xl text-center">
          <div className="bg-[#f8f9fa] p-8 lg:p-10 rounded-[12px] border border-[#dadce0]">
            <p className="text-[16px] text-[#3c4043] leading-relaxed mb-6 font-normal">
              Both S-Corps and C-Corps offer distinct advantages. The right choice depends on your business's specific circumstances, including your growth plans, tax situation, and investor needs.
            </p>
            <button 
              onClick={handleClick}
              className="bg-[#1a73e8] text-white px-8 py-3 rounded-[4px] font-medium text-[15px] hover:bg-[#1557b0] transition-colors shadow-md cursor-pointer"
            >
              Start Corporation Formation
            </button>
          </div>
        </div>
      </section>
    </div>
  )
}
